// extracted by mini-css-extract-plugin
module.exports = {"actual":"_02712f2b3b--actual--KF2Fy","label":"_02712f2b3b--label--DSBoP"};